import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  without: 'Horas planificando desde cero cada semana',
  with: '5 minutos. Todo listo.'
}, {
  without: 'Ejercicios improvisados sin progresión real',
  with: '+200 ejercicios graficados con progresión semanal'
}, {
  without: 'Grupos sin sistema claro ni avance visible',
  with: 'Estructura clara para cada nivel y objetivo'
}, {
  without: 'Miedo cuando entra un alumno con hernia o lesión',
  with: 'Protocolo listo para cada condición médica'
}, {
  without: 'No saber qué hacer con una alumna embarazada',
  with: 'Guía completa de embarazo, postparto y suelo pélvico'
}, {
  without: 'Siempre repetir los mismos cues de corrección',
  with: '100+ cues sensoriales organizados por zona'
}, {
  without: 'Sensación de improvisar siempre',
  with: 'Llegás a clase con todo resuelto'
}];
export function ComparisonTable() {
  return <section className="py-16 px-4 bg-white" data-id="element-39">
      <div className="max-w-5xl mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-42">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </motion.div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-43">
          <div className="grid md:grid-cols-2 bg-primary text-white font-bold text-center" data-id="element-44">
            <div className="p-4 border-r border-white/20" data-id="element-45">
              SIN STRETCHING 360
            </div>
            <div className="p-4" data-id="element-46">CON STRETCHING 360</div>
          </div>

          {comparisons.map((row, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="grid md:grid-cols-2 border-b border-gray-200 last:border-b-0" data-id="element-47">
              <div className="p-6 bg-surface-light border-r border-gray-200 flex items-start gap-3" data-id="element-48">
                <XIcon className="w-5 h-5 text-accent flex-shrink-0 mt-1" data-id="element-49" />
                <span className="text-gray-700" data-id="element-50">{row.without}</span>
              </div>
              <div className="p-6 bg-surface-accent flex items-start gap-3" data-id="element-51">
                <CheckIcon className="w-5 h-5 text-primary flex-shrink-0 mt-1" data-id="element-52" />
                <span className="text-gray-900 font-medium" data-id="element-53">{row.with}</span>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-xl font-bold text-gray-900 mt-8" data-id="element-54">
          El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
        </motion.p>
      </div>
    </section>;
}